export default __webpack_public_path__ + "static/media/spaceship.a23b62cf.gltf";